<template>
  <a-layout-sider
    width="220"
    style="background: #f8f8f8; box-sizing: border-box"
    v-model="collapsed"
    collapsible
  >
    <a-menu
      v-if="userMenuPower.menus"
      mode="inline"
      :defaultOpenKeys="['Manage']"
      :selectedKeys="selectedKeys"
      :style="{ minHeight: '100%', borderRight: 0 }"
      @click="handleClick"
    >
      <template v-for="menu in userMenuPower.menus">
        <a-menu-item :key="menu.name" v-if="menu.childs.length == 0">
          <i class="iconfont" :class="'icon-' + menu.name"></i>
          <a-icon
            style="display: none"
            class="iconfont"
            :class="'icon' + menu.name"
            :type="menu.name"
          />
          <span :data-label="'permission_' + menu.name"
            >&nbsp;{{ menu.description || "" }}</span
          >
        </a-menu-item>

        <a-sub-menu :key="menu.name" v-else>
          <span slot="title">
            <i class="iconfont" :class="'icon-' + menu.name"></i>
            <a-icon
              style="display: none"
              class="iconfont"
              :class="'icon' + menu.name"
              :type="menu.name"
            />
            <span>&nbsp;{{ menu.description }}</span>
          </span>
          <a-menu-item v-for="child in menu.childs" :key="child.name">
            <i class="iconfont" :class="'icon-' + child.name"></i>
            <span>&nbsp;{{ child.description || "" }}</span>
          </a-menu-item>
        </a-sub-menu>
      </template>
    </a-menu>
  </a-layout-sider>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Home",
  data() {
    return {
      collapsed: false,
      selectedKeys: []
    };
  },
  computed: {
    ...mapState(["userMenuPower"])
  },
  mounted() {
    let route_name = this.$route.name;
    this.selectedKeys = [route_name];
    let is_mobi =
      navigator.userAgent
        .toLowerCase()
        .match(
          /(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i
        ) != null;
    if (is_mobi) {
      this.collapsed = true;
    }
  },
  watch: {
    collapsed(v) {
      this.$store.commit("updateSiderCollapsed", v);
    }
  },
  methods: {
    handleClick(e) {
      this.selectedKeys = [e.key];
      this.$router.push({ name: e.key });
    }
  }
};
</script>

<style>
.ant-menu-item {
  font-weight: bold;
}
.ant-menu-submenu-title {
  font-weight: bold;
}
.ant-layout-sider-trigger {
  position: relative !important;
}
</style>
